import { Box, withStyles } from 'vopay';
import { Skeleton } from 'UI';
import styles from './DefaultFundingMethods.module.scss';

const cn = withStyles(styles);

export default function FundingMethodRowSkeleton() {
  return (
    <div className={cn('row')}>
      <Box ai="center" gapSize="16px" grow="1">
        <Skeleton circle width={48} height={48} />
        <Box flx="col" gapSize="4px" grow="1">
          <Skeleton width={160} height={20} />
          <Skeleton width={200} height={15} />
        </Box>
      </Box>
      <Box gapSize="8px" ai="center">
        <Skeleton width={90} height={32} borderRadius={8} />
        <Skeleton width={90} height={32} borderRadius={8} />
      </Box>
    </div>
  );
}
